<template>
  <div class="d-flex">
    <b-container fluid class="p-0">
      <b-row no-gutters>
        <b-col cols="4" class="pe-2">
          <v-text-field
            :label="$t('box')"
            v-model="rule.number"
            readonly
            dense
            outlined
            :error-messages="numberErrors"
            @blur="$v.rule.number.$touch()"
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.weight"
            :label="$t('weight_kg')"
            dense
            outlined
            type="number"
            min="0"
            :error-messages="weightErrors"
            @blur="$v.rule.weight.$touch()"
            @change="() => validateMinValue('weight', 0, 'rule')"
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.length"
            :label="$t('length_cm')"
            dense
            outlined
            type="number"
            min="0"
            :error-messages="lengthErrors"
            @blur="$v.rule.length.$touch()"
            @change="() => validateMinValue('length', 0, 'rule')"
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.width"
            :label="$t('width_cm')"
            dense
            outlined
            type="number"
            min="0"
            :error-messages="widthErrors"
            @blur="$v.rule.width.$touch()"
            @change="() => validateMinValue('width', 0, 'rule')"
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.height"
            :label="$t('height_cm')"
            dense
            outlined
            type="number"
            min="0"
            :error-messages="heightErrors"
            @blur="$v.rule.height.$touch()"
            @change="() => validateMinValue('height', 0, 'rule')"
          />
        </b-col>
      </b-row>
    </b-container>
    <div class="max-h-65">
      <button
        class="h-40px w-40px btn btn-sm btn-icon btn-light-info btn-hover-light"
        @click="deleteRule"
      >
        <span class="svg-icon">
          <v-icon size="18">mdi-delete</v-icon>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
import { validationMixin } from "vuelidate";
import { minValue, required } from "vuelidate/lib/validators";
import { SET_BOXES_DIMENSIONS_ADDED } from "@/core/services/store/orders.module";
export default {
  name: "Action",
  mixins: [validationMixin, fieldValueValidation],
  validations: {
    rule: {
      number: { required },
      weight: { required, minValue: minValue(0) },
      length: { required, minValue: minValue(0) },
      width: { required, minValue: minValue(0) },
      height: { required, minValue: minValue(0) },
    },
  },
  props: {
    rule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentRuleID: function () {
      return this.rule.number;
    },
    numberErrors: function () {
      return this.handleFormValidation("number", this, "rule");
    },
    lengthErrors: function () {
      return this.handleFormValidation("length", this, "rule");
    },
    weightErrors: function () {
      return this.handleFormValidation("weight", this, "rule");
    },
    widthErrors: function () {
      return this.handleFormValidation("width", this, "rule");
    },
    heightErrors: function () {
      return this.handleFormValidation("height", this, "rule");
    },
  },
  methods: {
    deleteRule() {
      this.$emit("delete-rule", this.rule.number);
    },
    handleFormValidation(fieldName, vueObj, dataName = "formData") {
      const errors = [];
      if (!vueObj.$v[`${dataName}`][fieldName].$dirty) return errors;
      if ("required" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("minValue" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].minValue &&
          errors.push(this.$t("validation_this_field_must_be_greater_than_0"));
      }

      return errors;
    },
  },
  watch: {
    rule: {
      handler() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$store.commit(SET_BOXES_DIMENSIONS_ADDED, false);
        } else {
          this.$store.commit(SET_BOXES_DIMENSIONS_ADDED, true);
        }
      },
      deep: true,
    },
  },
};
</script>
